<template>
  <div class="container-fluid mt-5">
    <div>
      <card
        class="no-bdelivery-card"
        body-classes="px-0 pb-1"
        footer-classes="pb-2"
      >
        <template slot="header">
          <div class="row">
            <div class="col-6">
              <h3 class="mb-0">
                {{ $t("SALES_DELIVERIES.SALES_DELIVERIES_LIST") }}
              </h3>
            </div>
            <div class="col-6 text-right">
              <!-- <base-button
                type="primary"
                icon
                size="sm"
                @click="addSalesDelivery()"
                v-if="
                  $currentUserCan($permissions.PERM_CREATE_SALES_DELIVERIES)
                "
              >
                <span class="btn-inner--icon">
                  <i class="fas fa-plus"></i>
                </span>
                <span class="btn-inner--text">
                  {{ $t("SALES_DELIVERIES.ADD_SALES_DELIVERY") }}
                </span>
              </base-button> -->

              <notification-subscription
                v-if="$currentUserCan($permissions.PERM_VIEW_SALES_DELIVERIES)"
                :objectType="'sales-deliveries'"
                :events="{
                  CREATE: $t('NOTIFICATIONS.EVENT_CREATE'),
                  UPDATE: $t('NOTIFICATIONS.EVENT_UPDATE'),
                  DELETE: $t('NOTIFICATIONS.EVENT_DELETE'),
                }"
              />
            </div>
          </div>
        </template>

        <sales-delivery-list-table
          :filterEstablishment="$route.query.establishment || null"
        />
      </card>
    </div>
  </div>
</template>
<script>
import { Button } from "element-ui";
import NotificationSubscription from "@/components/NotificationSubscription.vue";
import SalesDeliveryListTable from "./partials/SalesDeliveryListTable.vue";

export default {
  layout: "DashboardLayout",

  components: {
    SalesDeliveryListTable,
    NotificationSubscription,
    [Button.name]: Button,
  },

  mixins: [],

  computed: {},

  watch: {},

  methods: {
    addSalesDelivery() {
      this.$router.push({ name: "Add SalesDelivery" });
    },
  },
};
</script>
